// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/array-buffer-native.js
// module id = 254
// module chunks = 49